// extracted by mini-css-extract-plugin
export var divider = "contentHeader-module--divider--7QcaX";
export var img = "contentHeader-module--img--W7HDO";
export var img_template_2 = "contentHeader-module--img_template_2--feuxN";
export var main_img = "contentHeader-module--main_img--amQ6l";
export var main_logo_1 = "contentHeader-module--main_logo_1--rZfgi";
export var tagline = "contentHeader-module--tagline---Vqd3";
export var top_logos = "contentHeader-module--top_logos--VHsB3";
export var top_logos_link = "contentHeader-module--top_logos_link--jsLJD";